<script>
    import { Route, Router } from "svelte-navigator";
    import ProvisionWhizard from "./_Provision/ProvisionWhizard.svelte";
</script>

<Router>
    <main>
        <Route path="provision/*" let:params>
            <ProvisionWhizard />
        </Route>
    </main>
</Router>
